import { multiCaseGet } from 'libs/format';
import Validate from 'libs/validate';

export function getInitialFormData(user) {
  const { firstName = '', lastName = '', phoneNumber = '', email = '' } = user || {};

  return {
    firstName,
    lastName,
    phoneNumber,
    email,
  };
}

export function getUpdatePayload(user, formData) {
  const { firstName, lastName, phoneNumber, email } = formData || {};

  let payload = {
    firstName,
    lastName,
  };

  if (phoneNumber !== multiCaseGet(user, 'phoneNumber')) {
    payload = { ...payload, phoneNumber };
  }

  if (email !== multiCaseGet(user, 'email')) {
    payload = { ...payload, email };
  }

  return payload;
}

export function getFormValidationMessage(formData) {
  const { firstName, lastName, phoneNumber, email } = formData || {};

  if (!firstName) {
    return 'First Name is required';
  }

  if (!lastName) {
    return 'Last Name is required';
  }

  if (!phoneNumber) {
    return 'Phone Number is required';
  }

  if (!email) {
    return 'Email is required';
  }

  if (!Validate.validate(Validate.TYPES.EMAIL, email)) {
    return 'Email must be a valid email address';
  }

  return '';
}
